import { render, staticRenderFns } from "./AllDoctor.vue?vue&type=template&id=d052b650&scoped=true"
import script from "./AllDoctor.vue?vue&type=script&lang=js"
export * from "./AllDoctor.vue?vue&type=script&lang=js"
import style0 from "./AllDoctor.vue?vue&type=style&index=0&id=d052b650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d052b650",
  null
  
)

export default component.exports